!function (e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("react-bootstrap-tools"), require("react-bootstrap"), require("phyzzi.com-frontend-utils"));else if ("function" === typeof define && define.amd) define(["react", "react-bootstrap-tools", "react-bootstrap", "phyzzi.com-frontend-utils"], t);else {
    var n = "object" === typeof exports ? t(require("react"), require("react-bootstrap-tools"), require("react-bootstrap"), require("phyzzi.com-frontend-utils")) : t(e.react, e["react-bootstrap-tools"], e["react-bootstrap"], e["phyzzi.com-frontend-utils"]);

    for (var o in n) {
      ("object" === typeof exports ? exports : e)[o] = n[o];
    }
  }
}(window, function (e, t, n, o) {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 6);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Config = {
      url: {
        api: {
          checkboxes: "/api/checkbox/_SITE_"
        },
        register: "/auth/register",
        registerUsingProvider: "/auth/registerUsingProvider",
        resetPasswordRequest: "/auth/refreshPassword",
        login: "/auth/login",
        loginUsingProvider: "/auth/loginUsingProvider"
      },
      regex: {
        email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        password: /^.*(?=.{8,255})(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/
      },
      loginRegisterTimeout: 500
    }, t.default = t.Config;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__assign || function () {
      return (o = Object.assign || function (e) {
        for (var t, n = 1, o = arguments.length; n < o; n++) {
          for (var r in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.validateInput = function (e, t, n) {
      var o,
          r,
          a,
          s,
          i,
          l,
          c = t[e] || "";
      return 0 === c.length ? ((o = {})[e] = !1, o) : "email" !== e || n.email.test(c) ? "checkbox" === e && !1 === c ? ((a = {})[e] = !1, a) : "password" !== e || n.password.test(c) ? "passwordRepeat" !== e || n.password.test(c) && t.password === t.passwordRepeat ? ((l = {})[e] = !0, l) : ((i = {})[e] = !1, i) : ((s = {})[e] = !1, s) : ((r = {})[e] = !1, r);
    }, t.getAllowSend = function (e, n, o) {
      return !o && t.areAllMandatoryCheckboxesChecked(n.checkboxes) && Object.keys(e).every(function (t) {
        return !0 === e[t] && (!n[t] || 0 !== n[t].length);
      });
    }, t.getAllowSendSocial = function (e, n) {
      return !n && t.areAllMandatoryCheckboxesChecked(e);
    }, t.areAllMandatoryCheckboxesChecked = function (e) {
      return e.every(function (e) {
        return !e.mandatory || e.mandatory && e.checked;
      });
    }, t.getLabelClassName = function (e) {
      return "Register__checkbox-label" + (e ? "" : "--nonMandatory");
    }, t.getInputClassName = function (e) {
      return "Register__input" + (!1 === e ? "--invalid" : "");
    }, t.getCheckboxesContent = function (e, t) {
      var n = t.id,
          r = t.checked;
      return e.map(function (e) {
        return n !== e.id ? e : o(o({}, e), {
          checked: r
        });
      });
    }, t.validateCheckbox = function (e, n, o) {
      var r = n.id,
          a = n.checked,
          s = e.filter(function (e) {
        return e.id === r;
      })[0];
      return t.validateInput("checkbox", {
        checkbox: !s.mandatory || s.mandatory && a
      }, o).checkbox;
    }, t.handleFetchCheckboxesSuccess = function (e, t) {
      (0, e.successAction)(t);
    }, t.handleFetchCheckboxesFail = function (e) {
      (0, e.invokeInfo)({
        variant: "danger",
        message: "Register.alertFetchCheckboxFail"
      });
    };
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, n) {
    e.exports = n(7);
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = o(n(8));
    t.Login = r.default;
    var a = o(n(10));
    t.LoginError = a.default;
    var s = o(n(11));
    t.Register = s.default;
    var i = o(n(15));
    t.RegistrationSuccess = i.default;
    var l = o(n(16));
    t.RegistrationError = l.default;
    var c = o(n(17));
    t.Request = c.default;
    var u = o(n(19));
    t.RequestSuccess = u.default;
    var d = o(n(20));
    t.ResetError = d.default;
    var f = o(n(21));
    t.ResetFormError = f.default;
    var p = o(n(22));
    t.Reset = p.default;
    var h = o(n(24));
    t.ResetSuccess = h.default;
    var m = o(n(25));
    t.VerificationSuccess = m.default;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e = function e(t, n) {
        return (_e = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, o = arguments.length; n < o; n++) {
          for (var r in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    },
        s = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = a(n(0)),
        l = n(9),
        c = s(n(2)),
        u = n(1),
        d = n(3),
        f = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.formId = "loginSocial", n.formAction = "", n.providerFieldId = "providerFieldId", n.defaultState = {
          isSending: !1,
          content: {
            email: "",
            password: ""
          },
          isValid: {
            email: null,
            password: null
          },
          allowSend: !1
        }, n.handleInputChange = function (e, t) {
          var o,
              a,
              s = r(r({}, n.state.content), ((o = {})[e] = t, o)),
              i = r(r({}, n.state.isValid), ((a = {})[e] = l.validateInput(e, t, c.default.regex), a));
          n.setState({
            content: s,
            isValid: i,
            allowSend: l.getAllowSend(i, s, n.state.isSending)
          });
        }, n.login = function (e) {
          n.setState({
            isSending: !0
          }), n.fetchNewMessages = setTimeout(function () {
            document.getElementById(n.formId).action = e ? c.default.url.loginUsingProvider : c.default.url.login, document.getElementById(n.providerFieldId).value = e, document.getElementById(n.formId).submit();
          }, c.default.loginRegisterTimeout);
        }, n.loginUsingLinkedin = function () {
          n.login("linkedin");
        }, n.loginUsingGoogle = function () {
          n.login("google");
        }, n.loginWithNoProvider = function () {
          n.login();
        }, n.handleResetPasswordClick = function () {
          n.props.showModalContent({
            type: "resetPasswordRequest"
          });
        }, n.state = n.defaultState, n.t = t.t, n.loginButtonText = n.props.t("Login.formLoginText"), n.linkedinButtonDescription = n.props.t("Login.formLinkedinDescription"), n.googleButtonDescription = n.props.t("Login.formGoogleDescription"), n.resetPasswordButtonText = n.props.t("Login.formResetPasswordText"), n;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this,
            t = this.props,
            n = t.t,
            o = t.Interpolate,
            r = i.default.createElement(u.DescribedButton, {
          buttonClassName: "Login__forgot-password-button",
          text: this.resetPasswordButtonText,
          onClick: this.handleResetPasswordClick
        });
        return i.default.createElement("section", {
          className: "Login",
          id: "Login"
        }, i.default.createElement("div", {
          className: "Login__intro"
        }, n("Login.infoIntro")), i.default.createElement("form", {
          action: this.formAction,
          method: "POST",
          id: this.formId
        }, i.default.createElement("input", {
          type: "hidden",
          name: "_token",
          value: this.props.token
        }), i.default.createElement("input", {
          type: "hidden",
          name: "provider",
          id: this.providerFieldId,
          value: ""
        }), i.default.createElement("div", null, i.default.createElement(d.Form.Group, null, i.default.createElement(d.Form.Control, {
          type: "text",
          name: "email",
          placeholder: n("Login.formEmailPlaceholder"),
          className: "Login__input",
          onChange: function onChange(t) {
            return e.handleInputChange("email", t.target.value);
          },
          maxLength: 255,
          value: this.state.content.email,
          readOnly: this.state.isSending,
          isInvalid: !1 === this.state.isValid.email
        }), i.default.createElement(d.Form.Control.Feedback, null)), i.default.createElement(d.Form.Group, null, i.default.createElement(d.Form.Control, {
          type: "password",
          name: "password",
          placeholder: n("Login.formPasswordPlaceholder"),
          className: "Login__input",
          onChange: function onChange(t) {
            return e.handleInputChange("password", t.target.value);
          },
          maxLength: 255,
          value: this.state.content.password,
          readOnly: this.state.isSending,
          isInvalid: !1 === this.state.isValid.password
        }))), i.default.createElement("div", null, i.default.createElement(d.Form.Group, null, i.default.createElement(d.Form.Check, {
          id: "Login__checkbox",
          type: "Checkbox",
          className: "Login__checkbox",
          name: "remember",
          value: !0,
          readOnly: this.state.isSending,
          label: n("Login.formRememberMeLabel"),
          onChange: function onChange() {}
        }))), i.default.createElement("div", {
          className: "Login__providers"
        }, i.default.createElement(u.DescribedButton, {
          block: !0,
          text: this.loginButtonText,
          onClick: this.loginWithNoProvider,
          disabled: !this.state.allowSend || this.state.isSending,
          buttonClassName: "Login__button"
        }), i.default.createElement(u.DescribedButton, {
          block: !0,
          description: this.linkedinButtonDescription,
          onClick: this.loginUsingLinkedin,
          disabled: this.state.isSending,
          text: "Linkedin",
          buttonClassName: "Login__social--linkedin"
        }), i.default.createElement(u.DescribedButton, {
          block: !0,
          description: this.googleButtonDescription,
          onClick: this.loginUsingGoogle,
          disabled: this.state.isSending,
          text: "Google",
          buttonClassName: "Login__social--google"
        }))), i.default.createElement("div", {
          className: "Login__disclaimer"
        }, i.default.createElement(o, {
          i18nKey: "Login.disclaimerSet",
          useDangerouslySetInnerHTML: !0,
          resetPasswordButton: r
        })));
      }, t;
    }(i.PureComponent);

    t.LoginComponent = f, t.default = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.validateInput = function (e, t, n) {
      return 0 !== t.length && !("email" === e && !n.email.test(t));
    }, t.getAllowSend = function (e, t, n) {
      return !n && Object.keys(e).every(function (n) {
        return e[n] && 0 !== t[n].length;
      });
    };
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e2 = function e(t, n) {
        return (_e2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e2(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(n(0)),
        s = n(1),
        i = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.t;
        return a.default.createElement("section", {
          className: "Login"
        }, a.default.createElement("div", {
          className: "Login_info"
        }, e("Login.infoUnable")), a.default.createElement("div", {
          className: "Login__confirmation-glyph--fail"
        }, a.default.createElement(s.Glyphicon, {
          icon: "close"
        })));
      }, t;
    }(a.PureComponent);

    t.LoginErrorComponent = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e3 = function e(t, n) {
        return (_e3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e3(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, o = arguments.length; n < o; n++) {
          for (var r in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    },
        s = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = a(n(0)),
        l = n(4),
        c = s(n(2)),
        u = n(1),
        d = n(3),
        f = n(12),
        p = n(5);
    n(13);

    var h = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.formId = "registerSocial", n.formAction = "", n.selectedProvider = "", n.defaultState = {
          isLoadingCheckboxes: !0,
          isSending: !0,
          content: {
            name: "",
            surname: "",
            email: "",
            password: "",
            passwordRepeat: "",
            checkboxes: []
          },
          isValid: {
            name: null,
            surname: null,
            email: null,
            password: null,
            passwordRepeat: null
          },
          isVisualyValid: {
            name: !0,
            surname: !0,
            email: !0,
            password: !0,
            passwordRepeat: !0
          },
          allowSend: !1,
          allowSendSocial: !1
        }, n.getCheckboxes = function () {
          f.handleFetchCheckboxes({
            token: n.props.token,
            handleFetchCheckboxesSuccess: n.handleFetchCheckboxesSuccess,
            invokeInfo: n.props.invokeInfo
          });
        }, n.handleFetchCheckboxesSuccess = function (e) {
          var t = n.state.isValid,
              o = n.state.isVisualyValid;
          e.forEach(function (e) {
            t["checkbox_" + e.id] = !e.mandatory || null, o["checkbox_" + e.id] = !e.mandatory || null;
          }), n.setState({
            isLoadingCheckboxes: !1,
            isSending: !1,
            content: r(r({}, n.state.content), {
              checkboxes: e.sort(function (e, t) {
                return e.group_order > t.group_order ? 1 : -1;
              }).map(function (e) {
                return r(r({}, e), {
                  checked: e.checked_by_default
                });
              })
            }),
            isValid: t,
            isVisualyValid: o
          });
        }, n.handleInputChange = function (e, t) {
          var o,
              a = r(r({}, n.state.content), ((o = {})[e] = t, o)),
              s = r(r({}, n.state.isValid), l.validateInput(e, a, c.default.regex)),
              i = l.getAllowSend(s, a, n.state.isSending),
              u = l.getAllowSendSocial(a.checkboxes, n.state.isSending);
          n.setState({
            content: a,
            isValid: s,
            isVisualyValid: s,
            allowSend: i,
            allowSendSocial: u
          });
        }, n.toggleCheckbox = function (e, t) {
          var o,
              a = r(r({}, n.state.content), {
            checkboxes: l.getCheckboxesContent(n.state.content.checkboxes, {
              id: e,
              checked: t
            })
          }),
              s = l.validateCheckbox(a.checkboxes, {
            id: e,
            checked: t
          }, c.default.regex),
              i = r(r({}, n.state.isValid), ((o = {})["checkbox_" + e] = s, o)),
              u = l.getAllowSend(i, a, n.state.isSending),
              d = l.getAllowSendSocial(a.checkboxes, n.state.isSending);
          n.setState({
            content: a,
            isValid: i,
            isVisualyValid: i,
            allowSend: u,
            allowSendSocial: d
          });
        }, n.handleRegisterClick = function () {
          n.state.allowSend ? (n.selectedProvider = "", n.formAction = c.default.url.register, n.handleShowCaptcha(n.register)) : n.validateAllFields();
        }, n.validateAllFields = function (e) {
          void 0 === e && (e = !1);
          var t = n.state,
              o = t.content,
              r = t.isValid,
              a = t.isVisualyValid;
          Object.keys(a).forEach(function (e) {
            return a[e] = !0;
          }), Object.keys(o).forEach(function (t) {
            if ("checkboxes" === t) o.checkboxes.forEach(function (e) {
              var t = l.validateInput("checkbox", {
                checkbox: !e.mandatory || e.mandatory && e.checked
              }, c.default.regex);
              r["checkbox_" + e.id] = t.checkbox, a["checkbox_" + e.id] = t.checkbox;
            });else if (!e) {
              var n = l.validateInput(t, o, c.default.regex);
              Object.keys(n).forEach(function (e) {
                r[e] = n[e], a[e] = n[e];
              });
            }
          }), n.setState({
            isValid: r,
            isVisualyValid: a
          });
        }, n.register = function () {
          n.setState({
            isSending: !0
          }), setTimeout(function () {
            document.getElementById(n.formId).submit();
          }, c.default.loginRegisterTimeout);
        }, n.handleLinkedinClick = function () {
          n.handleSocialClick("linkedin");
        }, n.handleGoogleClick = function () {
          n.handleSocialClick("google");
        }, n.handleSocialClick = function (e) {
          n.state.allowSendSocial ? (n.selectedProvider = e, n.formAction = c.default.url.registerUsingProvider, n.handleShowCaptcha(n.registerUsingProvider)) : n.validateAllFields(!0);
        }, n.registerUsingProvider = function () {
          n.setState({
            isSending: !0
          }), setTimeout(function () {
            document.getElementById(n.formId).submit();
          }, c.default.loginRegisterTimeout);
        }, n.handleShowCaptcha = function (e) {
          n.props.activateCaptcha(e, "Register");
        }, n.handlePrivacyPolicyClick = function () {
          n.props.showModalContent({
            type: "privacyPolicy"
          });
        }, n.handleTermsOfUseClick = function () {
          n.props.showModalContent({
            type: "tou"
          });
        }, n.state = n.defaultState, n.t = t.t, n.registerButtonText = n.t("Register.formRegisterText"), n.linkedinButtonDescription = n.t("Register.formLinkedinDescription"), n.linkedinButtonCheckboxDescription = n.t("Register.formSocialCheckboxesInfo"), n.googleButtonDescription = n.t("Register.formGoogleDescription"), n.googleButtonCheckboxDescription = n.t("Register.formSocialCheckboxesInfo"), n.privacyPolicyButtonText = n.t("Register.privacyPolicyLink"), n.touButtonText = n.t("Register.termsOfUseLink"), n;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        this.getCheckboxes();
      }, t.prototype.render = function () {
        var e = this,
            t = this.props,
            n = t.t,
            o = t.Interpolate,
            r = i.default.createElement(u.DescribedButton, {
          onClick: this.handlePrivacyPolicyClick,
          text: this.privacyPolicyButtonText,
          buttonClassName: "Register__textLink"
        }),
            a = i.default.createElement(u.DescribedButton, {
          onClick: this.handleTermsOfUseClick,
          text: this.touButtonText,
          buttonClassName: "Register__textLink"
        });
        return i.default.createElement("section", {
          className: "Register",
          id: "Register"
        }, i.default.createElement("div", {
          className: "Register__intro"
        }, n("Register.infoIntro")), i.default.createElement("form", {
          action: this.formAction,
          method: "POST",
          id: this.formId
        }, i.default.createElement("input", {
          type: "hidden",
          name: "_token",
          value: this.props.token
        }), i.default.createElement("input", {
          type: "hidden",
          name: "provider",
          value: this.selectedProvider
        }), i.default.createElement("div", null, i.default.createElement(d.Form.Row, null, i.default.createElement(d.Form.Group, {
          as: d.Col
        }, i.default.createElement(d.Form.Control, {
          type: "text",
          name: "name",
          placeholder: n("Register.formNamePlaceholder"),
          className: l.getInputClassName(this.state.isVisualyValid.name),
          onChange: function onChange(t) {
            return e.handleInputChange("name", t.target.value);
          },
          maxLength: 255,
          value: this.state.content.name,
          readOnly: this.state.isSending,
          isInvalid: !this.state.isVisualyValid.name
        })), i.default.createElement(d.Form.Group, {
          as: d.Col
        }, i.default.createElement(d.Form.Control, {
          type: "text",
          name: "surname",
          placeholder: n("Register.formSurnamePlaceholder"),
          className: l.getInputClassName(this.state.isVisualyValid.surname),
          onChange: function onChange(t) {
            return e.handleInputChange("surname", t.target.value);
          },
          maxLength: 255,
          value: this.state.content.surname,
          readOnly: this.state.isSending,
          isInvalid: !1 === this.state.isVisualyValid.surname
        }))), i.default.createElement(d.Form.Group, null, i.default.createElement(d.Form.Control, {
          type: "text",
          name: "email",
          placeholder: n("Register.formEmailPlaceholder"),
          className: l.getInputClassName(this.state.isVisualyValid.email),
          onChange: function onChange(t) {
            return e.handleInputChange("email", t.target.value);
          },
          maxLength: 255,
          value: this.state.content.email,
          readOnly: this.state.isSending,
          isInvalid: !1 === this.state.isVisualyValid.email
        })), i.default.createElement(d.Form.Group, null, i.default.createElement(d.Form.Control, {
          type: "password",
          name: "password",
          placeholder: n("Register.formPasswordPlaceholder"),
          className: l.getInputClassName(this.state.isVisualyValid.password),
          onChange: function onChange(t) {
            return e.handleInputChange("password", t.target.value);
          },
          maxLength: 255,
          value: this.state.content.password,
          readOnly: this.state.isSending,
          isInvalid: !1 === this.state.isVisualyValid.password
        })), i.default.createElement(d.Form.Group, null, i.default.createElement(d.Form.Control, {
          type: "password",
          name: "passwordRepeat",
          placeholder: n("Register.formPasswordRepeatPlaceholder"),
          className: l.getInputClassName(this.state.isVisualyValid.passwordRepeat),
          onChange: function onChange(t) {
            return e.handleInputChange("passwordRepeat", t.target.value);
          },
          maxLength: 255,
          value: this.state.content.passwordRepeat,
          readOnly: this.state.isSending,
          isInvalid: !1 === this.state.isVisualyValid.passwordRepeat
        }))), i.default.createElement("div", null, this.state.isLoadingCheckboxes && i.default.createElement(p.PhyzziBrandLoader, null), this.state.content.checkboxes.map(function (t) {
          return i.default.createElement(d.Form.Group, {
            key: t.id
          }, i.default.createElement(d.Form.Check, {
            type: "checkbox",
            id: "Register__checkbox-" + t.id
          }, i.default.createElement(d.Form.Check.Input, {
            type: "checkbox",
            isInvalid: !1 === e.state.isVisualyValid["checkbox_" + t.id],
            name: "checkboxes[]",
            value: t.id,
            onChange: function onChange(n) {
              return e.toggleCheckbox(t.id, !t.checked);
            },
            checked: !!t.checked || null,
            readOnly: e.state.isSending
          }), i.default.createElement(d.Form.Check.Label, {
            className: l.getLabelClassName(t.mandatory)
          }, i.default.createElement(o, {
            i18nKey: "common:checkboxContent." + t.string_id,
            useDangerouslySetInnerHTML: !0,
            privacyPolicyLink: r,
            termsOfUseLink: a
          }), t.mandatory && i.default.createElement("span", {
            className: "Register__checkbox-label-asterisk"
          }, "*"))));
        })), i.default.createElement("div", {
          className: "Register__providers"
        }, i.default.createElement(u.DescribedButton, {
          block: !0,
          text: this.registerButtonText,
          onClick: this.handleRegisterClick,
          buttonClassName: "Register__button"
        }), i.default.createElement(u.DescribedButton, {
          block: !0,
          description: this.state.allowSendSocial ? this.linkedinButtonDescription : this.linkedinButtonCheckboxDescription,
          onClick: this.handleLinkedinClick,
          text: "Linkedin",
          buttonClassName: "Register__social--linkedin"
        }), i.default.createElement(u.DescribedButton, {
          block: !0,
          description: this.state.allowSendSocial ? this.googleButtonDescription : this.googleButtonCheckboxDescription,
          onClick: this.handleGoogleClick,
          text: "Google",
          buttonClassName: "Register__social--google"
        }))), i.default.createElement("div", {
          className: "Register__disclaimer"
        }, n("Register.disclaimer")));
      }, t;
    }(i.Component);

    t.RegisterComponent = h, t.default = h;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(5),
        a = o(n(2)),
        s = n(4);

    t.handleFetchCheckboxes = function (e) {
      var t = e.handleFetchCheckboxesSuccess,
          n = e.invokeInfo;
      r.handleFetch({
        url: a.default.url.api.checkboxes.replace("_SITE_", encodeURIComponent("register")),
        token: e.token,
        callbackArg: {
          successAction: t,
          invokeInfo: n
        }
      }, {
        success: s.handleFetchCheckboxesSuccess,
        error: s.handleFetchCheckboxesFail
      });
    };
  }, function (e, t, n) {},, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e4 = function e(t, n) {
        return (_e4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e4(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(n(0)),
        s = n(1),
        i = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.t;
        return a.default.createElement("section", {
          className: "Register"
        }, a.default.createElement("div", {
          className: "Register_info"
        }, e("Register.infoSuccess")), a.default.createElement("div", {
          className: "Register__confirmation-glyph--success"
        }, a.default.createElement(s.Glyphicon, {
          icon: "done"
        })));
      }, t;
    }(a.PureComponent);

    t.RegistrationSuccessComponent = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e5 = function e(t, n) {
        return (_e5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e5(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(n(0)),
        s = n(1),
        i = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.t;
        return a.default.createElement("section", {
          className: "Register"
        }, a.default.createElement("div", {
          className: "Register_info"
        }, e("Register.infoFail")), a.default.createElement("div", {
          className: "Register__confirmation-glyph--fail"
        }, a.default.createElement(s.Glyphicon, {
          icon: "close"
        })));
      }, t;
    }(a.PureComponent);

    t.RegistrationErrorComponent = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e6 = function e(t, n) {
        return (_e6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e6(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    },
        a = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = r(n(0)),
        i = n(18),
        l = a(n(2)),
        c = n(1),
        u = n(3),
        d = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.formId = "ResetPasswordRequestForm", n.defaultState = {
          isSending: !1,
          allowSend: !1,
          isValid: null,
          content: ""
        }, n.handleInputChange = function (e, t) {
          var o = i.validateInput(t, l.default.regex),
              r = o;
          n.setState({
            allowSend: r,
            isValid: o,
            content: t
          });
        }, n.handleResetPasswordRequestClick = function () {
          n.handleShowCaptcha(n.ResetPasswordRequest);
        }, n.ResetPasswordRequest = function () {
          n.setState({
            isSending: !0
          });
          var e = document.getElementById(n.formId);
          e && e.submit();
        }, n.handleShowCaptcha = function (e) {
          n.props.activateCaptcha(e, "Reset password request");
        }, n.state = n.defaultState, n.t = t.t, n.sendButtonText = n.t("ResetPasswordRequest.formRequestText"), n;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this,
            t = this.props.t;
        return s.default.createElement("section", {
          className: "ResetPasswordRequest"
        }, s.default.createElement("div", {
          className: "ResetPasswordRequest__intro"
        }, t("ResetPasswordRequest.infoIntro")), s.default.createElement("form", {
          action: l.default.url.resetPasswordRequest,
          method: "POST",
          id: this.formId
        }, s.default.createElement("input", {
          type: "hidden",
          name: "_token",
          value: this.props.token
        }), s.default.createElement("div", null, s.default.createElement(u.Form.Group, null, s.default.createElement(u.Form.Control, {
          type: "email",
          name: "email",
          placeholder: t("ResetPasswordRequest.formEmailPlaceholder"),
          className: "ResetPasswordRequest__input",
          onChange: function onChange(t) {
            return e.handleInputChange("email", t.target.value);
          },
          maxLength: 255,
          value: this.state.content,
          readOnly: this.state.isSending,
          isInvalid: !1 === this.state.isValid
        }))), s.default.createElement("div", {
          className: "ResetPasswordRequest__providers"
        }, s.default.createElement(c.DescribedButton, {
          text: this.sendButtonText,
          onClick: this.handleResetPasswordRequestClick,
          buttonClassName: "ResetPasswordRequest__button",
          disabled: !this.state.allowSend || this.state.isSending
        }))), s.default.createElement("div", {
          className: "ResetPasswordRequest__disclaimer"
        }, t("ResetPasswordRequest.disclaimer")));
      }, t;
    }(s.PureComponent);

    t.RequestComponent = d, t.default = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.validateInput = function (e, t) {
      return 0 !== e.length && !!t.email.test(e);
    };
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e7 = function e(t, n) {
        return (_e7 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e7(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(n(0)),
        s = n(1),
        i = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.t;
        return a.default.createElement("section", {
          className: "ResetPasswordRequest"
        }, a.default.createElement("div", {
          className: "ResetPasswordRequest_info"
        }, e("ResetPasswordRequest.infoSuccess")), a.default.createElement("div", {
          className: "ResetPasswordRequest__confirmation-glyph--success"
        }, a.default.createElement(s.Glyphicon, {
          icon: "done"
        })));
      }, t;
    }(a.PureComponent);

    t.RequestSuccessComponent = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e8 = function e(t, n) {
        return (_e8 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e8(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(n(0)),
        s = n(1),
        i = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.t;
        return a.default.createElement("section", {
          className: "ResetPassword"
        }, a.default.createElement("div", {
          className: "ResetPassword_info"
        }, e("ResetPassword.infoResetError")), a.default.createElement("div", {
          className: "ResetPassword__confirmation-glyph--fail"
        }, a.default.createElement(s.Glyphicon, {
          icon: "close"
        })));
      }, t;
    }(a.PureComponent);

    t.ResetErrorComponent = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e9 = function e(t, n) {
        return (_e9 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e9(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(n(0)),
        s = n(1),
        i = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.t;
        return a.default.createElement("section", {
          className: "ResetPassword"
        }, a.default.createElement("div", {
          className: "ResetPassword_info"
        }, e("ResetPassword.infoLinkError")), a.default.createElement("div", {
          className: "ResetPassword__confirmation-glyph--fail"
        }, a.default.createElement(s.Glyphicon, {
          icon: "close"
        })));
      }, t;
    }(a.PureComponent);

    t.ResetFormErrorComponent = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e10 = function e(t, n) {
        return (_e10 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e10(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, o = arguments.length; n < o; n++) {
          for (var r in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    },
        s = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = a(n(0)),
        l = n(23),
        c = s(n(2)),
        u = n(1),
        d = n(3),
        f = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.formId = "resetPasswordForm", n.defaultState = {
          isSending: !1,
          allowSend: !1,
          isValid: {
            password: null,
            passwordRepeat: null
          },
          content: {
            password: "",
            passwordRepeat: ""
          }
        }, n.handleInputChange = function (e, t) {
          var o,
              a = r(r({}, n.state.content), ((o = {})[e] = t, o)),
              s = r(r({}, n.state.isValid), l.validateInput(e, a, c.default.regex)),
              i = l.getAllowSend(s, a, n.state.isSending);
          n.setState({
            content: a,
            isValid: s,
            allowSend: i
          });
        }, n.handleResetPasswordClick = function () {
          n.handleShowCaptcha(n.ResetPassword);
        }, n.ResetPassword = function () {
          n.setState({
            isSending: !0
          });
          var e = document.getElementById(n.formId);
          e && e.submit();
        }, n.handleShowCaptcha = function (e) {
          n.props.activateCaptcha(e, "Reset password");
        }, n.state = n.defaultState, n.t = t.t, n.sendButtonText = n.t("ResetPassword.formResetText"), n;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this,
            t = this.props.t;
        return i.default.createElement("section", {
          className: "ResetPassword"
        }, i.default.createElement("div", {
          className: "ResetPassword__intro"
        }, t("ResetPassword.infoIntro")), i.default.createElement("form", {
          action: this.props.url,
          method: "POST",
          id: this.formId
        }, i.default.createElement("input", {
          type: "hidden",
          name: "_token",
          value: this.props.token
        }), i.default.createElement("div", null, i.default.createElement(d.Form.Group, null, i.default.createElement(d.Form.Control, {
          type: "password",
          name: "password",
          placeholder: t("ResetPassword.formPasswordPlaceholder"),
          className: "ResetPassword__input",
          onChange: function onChange(t) {
            return e.handleInputChange("password", t.target.value);
          },
          maxLength: 255,
          value: this.state.content.password,
          readOnly: this.state.isSending,
          isInvalid: !1 === this.state.isValid.password
        }))), i.default.createElement("div", null, i.default.createElement(d.Form.Group, null, i.default.createElement(d.Form.Control, {
          type: "password",
          name: "passwordRepeat",
          placeholder: t("ResetPassword.formPasswordRepeatPlaceholder"),
          className: "ResetPassword__input",
          onChange: function onChange(t) {
            return e.handleInputChange("passwordRepeat", t.target.value);
          },
          maxLength: 255,
          value: this.state.content.passwordRepeat,
          readOnly: this.state.isSending,
          isInvalid: !1 === this.state.isValid.passwordRepeat
        }))), i.default.createElement("div", {
          className: "ResetPassword__providers"
        }, i.default.createElement(u.DescribedButton, {
          text: this.sendButtonText,
          onClick: this.handleResetPasswordClick,
          buttonClassName: "ResetPassword__button",
          disabled: !this.state.allowSend || this.state.isSending
        }))), i.default.createElement("div", {
          className: "ResetPassword__disclaimer"
        }, t("ResetPassword.disclaimer")));
      }, t;
    }(i.PureComponent);

    t.ResetComponent = f, t.default = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.validateInput = function (e, t, n) {
      var o,
          r,
          a,
          s,
          i = t[e] || "";
      return 0 === i.length ? ((o = {})[e] = !1, o) : n.password.test(i) ? "passwordRepeat" !== e || n.password.test(i) && t.password === t.passwordRepeat ? ((s = {})[e] = !0, s) : ((a = {})[e] = !1, a) : ((r = {})[e] = !1, r);
    }, t.getAllowSend = function (e, t, n) {
      return !n && Object.keys(e).every(function (n) {
        return !0 === e[n] && (!t[n] || 0 !== t[n].length);
      });
    };
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e11 = function e(t, n) {
        return (_e11 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e11(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(n(0)),
        s = n(1),
        i = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.t;
        return a.default.createElement("section", {
          className: "ResetPassword"
        }, a.default.createElement("div", {
          className: "ResetPassword_info"
        }, e("ResetPassword.infoResetSuccess")), a.default.createElement("div", {
          className: "ResetPassword__confirmation-glyph--success"
        }, a.default.createElement(s.Glyphicon, {
          icon: "done"
        })));
      }, t;
    }(a.PureComponent);

    t.ResetSuccessComponent = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__extends || function () {
      var _e12 = function e(t, n) {
        return (_e12 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function o() {
          this.constructor = t;
        }

        _e12(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o());
      };
    }(),
        r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(n(0)),
        s = n(1),
        i = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.t;
        return a.default.createElement("section", {
          className: "Register"
        }, a.default.createElement("div", {
          className: "Register_info"
        }, e("Register.infoVerificationSuccess")), a.default.createElement("div", {
          className: "Register__confirmation-glyph--success"
        }, a.default.createElement(s.Glyphicon, {
          icon: "done"
        })));
      }, t;
    }(a.PureComponent);

    t.VerificationSuccessComponent = i, t.default = i;
  }]);
});